<template>
    <div>
        <div :class="'alert alert-' + type" v-show="finalMessage != null" v-html="finalMessage">            
        </div>
    </div>
</template>

<script>    
    export default {
        name: 'alert-message',
        props: {
            type: {
                type: String,
                default: 'danger'
            },
            errors: {                
            },
            message: {
                type: String
            },
            timeout: {
                type: Number,
                default: 0
            }
        },
        watch: {
            message() {
                this.message2 = this.message;
            }
        },
        data() {
            return {
                message2: this.message
            }
        },
        computed: {
            finalMessage() {
                var self = this;
                var e = self.errorMessage;

                if (e != null) {
                    if (self.timeout > 0) {                        
                        setTimeout(function () {
                            self.errors.errors = [];
                        }, self.timeout);
                    }

                    return e;
                }

                var m = self.message2 || null;

                if (m != null && self.timeout > 0) {                    
                    setTimeout(function () {
                        self.message2 = null;
                    }, self.timeout);
                }

                return m;
            },
            errorMessage() {
                var self = this;
                if (self.errors == null || self.errors.length == 0) {
                    return null;
                }

                if (self.errors.errors == undefined || self.errors.errors == null || self.errors.errors.length == 0) {
                    return null;
                }

                return self.errors.errors.map((x) => { return x.value }).join('<br />');                
            }
        }
    }
</script>




// WEBPACK FOOTER //
// _alert-message.vue?e8f0c9c6